<template>
    <button
        type="button"
        class="absolute top-1/2 left-0 z-10 -translate-y-1/2 cursor-pointer rounded-sm bg-green-300 p-3 transition-opacity duration-200 hover:bg-green-500 disabled:opacity-0 lg:left-10">
        <ArrowLeftIcon class="mx-auto !w-4 stroke-[2.5px] text-black lg:!w-5" />
    </button>
</template>

<script setup lang="ts">
    import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
</script>
